import { Button, Modal, SecondaryButton } from 'components';
import { StyledAdminAddModal } from './styles';
import { ReactComponent as CloseIcon } from 'assets/icons/close-modal-icon.svg';
import { useTranslation } from 'react-i18next';

interface IAdminAddModalProps {
  children?: React.ReactNode;
  title: string;
  onConfirm: () => void;
  onCancel: () => void;
  show: boolean;
}

export const AdminAddModal = ({
  children,
  title,
  onConfirm,
  onCancel,
  show,
}: IAdminAddModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal show={show}>
      <StyledAdminAddModal>
        <div className="add-modal-topline">
          <h3 className="add-modal-title">{title}</h3>
          <button className="add-modal-button" onClick={onCancel}>
            <CloseIcon />
          </button>
        </div>
        <div className="add-modal-body">{children}</div>
        <div className="add-modal-buttons">
          <SecondaryButton title={t('adminPage.confirmModal.cancel')} outline onClick={onCancel} />
          <Button title={t('adminPage.confirmModal.add')} onClick={onConfirm} />
        </div>
      </StyledAdminAddModal>
    </Modal>
  );
};
